export default __webpack_public_path__ + "static/media/madame_detail11.a64b0860.jpg";